module.exports = __webpack_public_path__ + "static/media/cookie.4c8d37e6.jpg";